// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinVerifiedAppsAndGamesSection_container__NTRBu"};